import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-123f16a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page-box"
};
const _hoisted_2 = {
  class: "generic-title"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = {
  class: "time"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "content-box"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "relatedPosts"
};
const _hoisted_9 = {
  class: "box"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "相关阅读", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_com = _resolveComponent("header-com");
  const _component_article_com = _resolveComponent("article-com");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_row = _resolveComponent("a-row");
  const _component_footer_com = _resolveComponent("footer-com");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_header_com), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.blogInfo.blogTime), 1), _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.blogInfo.blogTitle), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "content",
    innerHTML: _ctx.blogInfo.blogContent
  }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_a_row, {
    class: "list-box",
    gutter: [24, 24]
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleList, (item, index) => {
      return _openBlock(), _createBlock(_component_a_col, {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        key: index
      }, {
        default: _withCtx(() => [_createVNode(_component_article_com, {
          articleItem: item
        }, null, 8, ["articleItem"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])]), _createVNode(_component_footer_com)]);
}